import React, { type FC, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { GQL } from "@binale-tech/shared";
import { useLocation } from "react-router-dom";
import { AppRoutes } from "@domain/routing/routeConstants";
import { ModuleNav, type NavItem } from "./ModuleNav";

export const ModuleLALinks: FC<{ onOpenSettings: (pk: GQL.IProductKey) => void }> = ({ onOpenSettings }) => {
    const { pathname = "" } = useLocation();
    const selectedKeys = useMemo(() => [pathname], [pathname]);
    const items = useMemo<NavItem[]>(
        () => [
            {
                key: AppRoutes.paySlipTemplates,
                to: AppRoutes.paySlipTemplates,
                label: <FormattedMessage id="app.titles.templates" />,
            },
            {
                key: "settings",
                onClick: () => onOpenSettings(GQL.IProductKey.La),
                label: <FormattedMessage id="app.titles.settings" />,
            },
        ],
        [onOpenSettings],
    );
    return <ModuleNav selectedKeys={selectedKeys} items={items} />;
};
